import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import appReducer from "./app-reducer";
import captchaReducer from "./captcha-reducer";
import reduxFormReducer, { fieldReducer } from "./form-reducer";

const reducer = combineReducers({
  form: reduxFormReducer,
  fields: fieldReducer,
  captcha: captchaReducer,
  app: appReducer
});

const middleware = applyMiddleware(thunk);

const store = createStore(reducer, compose(middleware, window.devToolsExtension ? window.devToolsExtension() : f => f));
export default store;
